import usePMConfig from './usePMConfig';
import { PmMetricsHeader } from './generalConfigSections';
import { ARTICLE_IDS } from 'common/constants/constants';
import Text from 'components/base/Text';
import { SPACES } from 'common/constants/sizes';
import useSettingsService from 'components/hooks/useSettingsService';
import { FEATURE_FLAGS_NAMES } from '@linearb/linjs-common';
import { MTTRDuration } from './MTTRDuration';
import _ from 'lodash';
import { CfrMttrFilterSelector } from './CfrMttrFilterSelector';
import { Margin, Flex, Padding } from 'components/base/layout-components';
import { StyledFiltersSection } from '../connected-components/PMConfiguration/components/PMIncidentsSettings/pmIncidentsSettings.style';
import ToggleBox from 'components/ToggleBox';
import { ConfigBoxTitle } from './ConfigBoxTitle';
import usePmProvider from 'components/hooks/PM/usePmProvider';

const MTTRTitle = 'MTTR';
const MTTRText =
  'Mean Time To Restore (MTTR) is the duration from when a critical bug is reported until it is fixed and deployed.';

const MTTRConfig = ({
  history,
  toggleSnackBar,
  teamId,
  setConfiguration = _.noop,
  isUsingParentConfig = false,
  parentConfiguration,
  isOrgSettings
}) => {
  const { getSettingOrDefinitionValue } = useSettingsService();

  const isMTTRDurationEnabled = getSettingOrDefinitionValue({
    name: FEATURE_FLAGS_NAMES.isMTTRDurationEnabled
  });

  const pmProvider = usePmProvider();

  const {
    issueTypes,
    customFields,
    saveSettings,
    selectedFilters,
    isLoadingFilters,
    statuses,
    incidentStrategy,
    setIncidentStrategy,
    incidentConfig,
    setIncidentConfig,
    isSaveEnabled,
    dateTimeCustomFields,
    updateFiltersAtIndex,
    addCondition,
    removeCondition
  } = usePMConfig({
    toggleSnackBar,
    teamId,
    setConfiguration,
    isUsingParentConfig,
    parentConfiguration
  });

  return (
    <>
      <Padding b='medium'>
        <PmMetricsHeader
          history={history}
          saveSettings={saveSettings}
          title={`${MTTRTitle} Configuration`}
          text={MTTRText}
          articleId={ARTICLE_IDS.PM_MTTR}
          isSaveEnabled={isSaveEnabled}
          isOrgSettings={isOrgSettings}
        />
      </Padding>

      <StyledFiltersSection>
        <ToggleBox
          title={
            <ConfigBoxTitle
              title={MTTRTitle}
              count={selectedFilters?.length}
              isUsingParentConfig={isUsingParentConfig}
              teamId={teamId}
            />
          }
          collapsed={true}
        >
          <Flex padding='2rem' direction='column' data-cy='mttr-config-box'>
            <Text size='medium' pb={SPACES.medium} color='shuttleGray'>
              How should LinearB recognize critical bugs to track MTTR? (Select
              one or more):
            </Text>
            <Margin t='small' b='small'>
              <CfrMttrFilterSelector
                selectedFilters={selectedFilters}
                issueTypes={issueTypes}
                customFields={customFields}
                isLoadingFilters={isLoadingFilters}
                onAddFiltersSelector={addCondition}
                metricName={MTTRTitle}
                updateFiltersAtIndex={updateFiltersAtIndex}
                removeCondition={removeCondition}
                pmProvider={pmProvider}
              />
            </Margin>
          </Flex>
        </ToggleBox>
      </StyledFiltersSection>
      {isMTTRDurationEnabled && !isLoadingFilters && isOrgSettings && (
        <MTTRDuration
          itemsList={issueTypes}
          statuses={statuses}
          customFields={dateTimeCustomFields}
          incidentConfig={incidentConfig}
          setIncidentConfig={setIncidentConfig}
          incidentStrategy={incidentStrategy}
          setIncidentStrategy={setIncidentStrategy}
        />
      )}
    </>
  );
};

export default MTTRConfig;
